/* R22 · Search panel (snippets/cebe-search-panel.liquid): the magnifier opens the field in place, suggestions come from
   Shopify's predictive search rendered by sections/cebe-predictive-search.liquid. Without JavaScript the magnifier is a
   plain link to /search, and Return always submits the form to /search. */
(function () {
  'use strict';
  function init() {
    var panel = document.querySelector('[data-cebe-search-panel]');
    if (!panel || panel.hasAttribute('data-cebe-search-ready')) return;
    panel.setAttribute('data-cebe-search-ready', '');
    var sheet = panel.querySelector('[role="dialog"]');
    var input = panel.querySelector('[data-cebe-search-input]');
    var results = panel.querySelector('[data-cebe-search-results]');
    var quick = panel.querySelector('[data-cebe-search-quick]');
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-cebe-search-open]'));
    var suggestUrl = panel.getAttribute('data-suggest-url');
    var root = document.documentElement;
    var trigger = null;
    var timer = null;
    var controller = null;
    var cache = {};

    function isOpen() {
      return !panel.hidden;
    }
    function open(from) {
      trigger = from || null;
      panel.hidden = false;
      root.classList.add('cebe-search-open');
      openers.forEach(function (opener) { opener.setAttribute('aria-expanded', 'true'); });
      // Focus inside the tap itself, so iOS brings up the keyboard at once.
      input.focus();
      if (input.value) input.select();
      window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
    }
    function close(restoreFocus) {
      if (!isOpen()) return;
      window.clearTimeout(timer);
      if (controller) controller.abort();
      panel.classList.remove('is-open');
      panel.hidden = true;
      root.classList.remove('cebe-search-open');
      openers.forEach(function (opener) { opener.setAttribute('aria-expanded', 'false'); });
      if (restoreFocus !== false && trigger) trigger.focus();
    }
    // K789 I-13: the bag and the desktop menu close the search, so only one layer is open
    if (window.cebe) window.cebe.closeSearch = function () {
      close(false);
      if (panel.contains(document.activeElement)) document.activeElement.blur(); // no focus left in the hidden panel
    };
    function render(html, count) {
      results.innerHTML = html;
      var status = panel.querySelector('[data-cebe-search-status]');
      var block = results.querySelector('[data-cebe-predictive]');
      if (status) status.textContent = block ? block.getAttribute('data-status') || '' : '';
      if (quick) quick.hidden = count > 0;
    }
    function suggest(raw) {
      var terms = raw.trim();
      if (controller) controller.abort();
      if (!terms) {
        render('', 0);
        return;
      }
      if (cache[terms]) {
        render(cache[terms].html, cache[terms].count);
        return;
      }
      controller = window.AbortController ? new AbortController() : null;
      var url = suggestUrl + '?q=' + encodeURIComponent(terms) +
        '&section_id=cebe-predictive-search' +
        '&resources[type]=product,page,article&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var block = doc.querySelector('[data-cebe-predictive]');
          var entry = { html: block ? block.outerHTML : '', count: block ? parseInt(block.getAttribute('data-count'), 10) || 0 : 0 };
          cache[terms] = entry;
          if (input.value.trim() === terms) render(entry.html, entry.count);
        })
        .catch(function (error) {
          // K789 I-12: no stale suggestions for an older word; aborted requests are expected
          if (error && error.name === 'AbortError') return;
          if (input.value.trim() === terms) render('', 0);
        });
    }
    function options() {
      return Array.prototype.slice.call(panel.querySelectorAll('[data-cebe-search-option]')).filter(function (el) {
        return el.offsetParent !== null;
      });
    }
    function focusables() {
      return Array.prototype.slice.call(sheet.querySelectorAll('a[href], button, input:not([type="hidden"])')).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
    }

    openers.forEach(function (opener) {
      opener.setAttribute('aria-controls', panel.id);
      opener.setAttribute('aria-expanded', 'false');
      opener.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault();
        if (isOpen()) close();
        else open(opener);
      });
    });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-cebe-search-close]'), function (button) {
      button.addEventListener('click', function () { close(); });
    });
    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var value = input.value;
      timer = window.setTimeout(function () { suggest(value); }, 120);
    });
    panel.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close();
        return;
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        var list = options();
        if (!list.length) return;
        var index = list.indexOf(document.activeElement);
        event.preventDefault();
        if (event.key === 'ArrowDown') {
          list[index < 0 ? 0 : Math.min(index + 1, list.length - 1)].focus();
        } else if (index <= 0) {
          input.focus();
        } else {
          list[index - 1].focus();
        }
        return;
      }
      if (event.key === 'Tab') {
        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) close(false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
